import { HB_IMG_RETRY } from "@/constants/cacheKey";
import { EVENT } from "@/constants/event";
import { PIN_CARD_MAX_HEIGHT } from "@/constants/pin";
import useAppStore from "@/context/store";
import { gdSlsLog } from "@/utils/gdSlsRum";
import imageUrl from "@/utils/imageUrl";
import { imageUrlConfig } from "@/utils/imageUrlConfig";
import classNames from "classnames";
import { useEffect } from "react";
import styles from "./index.module.less";

// 取一张默认头像图片数据重试
const file = {
  bucket: "hbimg",
  height: 300,
  key: "654953460733026a7ef6e101404055627ad51784a95c-B6OFs4",
  type: "image/jpeg",
  width: 300,
};
const loadImage = (domain, bucketHandMethod) => {
  const bucket = imageUrlConfig.getBucket(file.bucket, bucketHandMethod);
  const url = imageUrl(file, { domain, bucket, width: 75, rect: "sq" });

  return new Promise((resolve) => {
    const image = new Image();
    image.onload = () => {
      // 加载成功，返回配置
      resolve({ domain, bucketHandMethod });
    };
    // 添加随机参数避免缓存
    image.src = `${url}?time=${Date.now()}`;
  });
};
// 初始化
if (typeof window !== "undefined") {
  const errorList = [];
  let timeoutLable = null;

  const switchImageUrlConfig = (e) => {
    errorList.push(e.detail.src || "Empty");

    // 20s内清除错误列表，防止长期访问累计后切换域名
    clearTimeout(timeoutLable);
    timeoutLable = setTimeout(() => {
      errorList.length = 0;
    }, 20 * 1000);

    // 错误上限，自动切换域名
    if (errorList.length > 10) {
      let isRetry = sessionStorage.getItem(HB_IMG_RETRY);
      // 判断是否重试过
      if (isRetry !== "true") {
        const imageConfigList =
          useAppStore.getState().config?.imageConfigList || [];
        // 根据杂货铺配置进行重试，找到最快能正常请求的图片配置
        Promise.race(
          imageConfigList?.map((item) => {
            return loadImage(item.domain, item.bucketHandMethod);
          })
        ).then((res) => {
          imageUrlConfig.set(res);
          sessionStorage.setItem(HB_IMG_RETRY, "true");

          gdSlsLog({
            type: "autoSwitchImage",
            message: "图片自动切换域名：切换成功",
            detail: res,
          });

          setTimeout(() => {
            // 延迟刷新，预留日志上报时间
            window.location.reload();
          }, 200);
        });
      }
      // 解绑事件
      window.removeEventListener(EVENT.IMAGE_LOAD_ERROR, switchImageUrlConfig);
    }
  };

  window.addEventListener(EVENT.IMAGE_LOAD_ERROR, switchImageUrlConfig);
}

export default function LoadErrorImage({
  src,
  srcset = "",
  width,
  height,
  limit = false,
}) {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const event = new CustomEvent(EVENT.IMAGE_LOAD_ERROR, {
        detail: { src },
      });

      window.dispatchEvent(event);
    }
  }, [src]);

  return (
    <div
      className={classNames(
        styles.error,
        height >= PIN_CARD_MAX_HEIGHT && limit ? styles.limit : null,
        "hb-image-error"
      )}
      style={{ width: `${width}px`, height: `${height}px` }}
      data-img-src={src}
      data-img-srcset={srcset}
    />
  );
}
